import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';
import Pills from './filters/Pills';
import sanitizeHtml from 'sanitize-html';
import Search from './filters/Search';
import { useSettingsContext } from '../contexts/settings';

const Filters = () => {
	const { tax } = useFiltersContext();
	const settings = useSettingsContext();

	const taxEntries = Object.entries(tax);
	if (taxEntries.length) {
		return (
			<div className="pfa-filters">
				{taxEntries.map(([key, taxonomy]) => {
					return (
						<div className="pfa-filters__filter" key={key}>
							<div className="pfa-filters__title">{taxonomy.labels.singular}</div>
							<Pills taxonomy={taxonomy} />
						</div>
					);
				})}
				{settings.showSearch && (
					<div className="pfa-filters__filter">
						<div
							className="pfa-filters__title"
							dangerouslySetInnerHTML={{ __html: sanitizeHtml(settings.searchTitle) }}
						/>
						<Search />
					</div>
				)}
			</div>
		);
	}

	return <></>;
};

Filters.displayName = 'Filters';

export default Filters;
